// ----------------------------------------------------------------------

export default function Link(theme?:React.CSSProperties | any) {
  return {
    MuiLink: {
      defaultProps: {
        underline: 'hover',
      },
    },
  };
}
